import { useTranslation } from "react-i18next";
import { Container } from "@mantine/core";
import { useAuth } from "@/contexts/AuthContext";
import Logo from "@/components/atoms/Logo";
import Stack from "@/components/atoms/Stack";
import Heading from "@/components/atoms/Heading";
import Text from "@/components/atoms/Text";
import Select from "@/components/atoms/Select";
import CTA from "@/components/atoms/CTA";

/**
 * Shown instead of the whole app while the current company awaits Reviver approval, and on /registerCompany once the
 * form is submitted. The user can only switch to another company or log out.
 */
export default function AwaitingApproval() {
  const { t } = useTranslation();
  const { currentCompany, companies, changeCompany, signOut } = useAuth();

  const otherCompanies = companies.filter((company) => company.companyId !== currentCompany?.companyId);

  return (
    <Container size="sm" py={60} data-testid="awaiting-approval">
      <Stack gap="lg">
        <Logo />
        {currentCompany?.companyName && (
          <Text size="sm" color="secondary" data-testid="awaiting-approval-company">
            {currentCompany.companyName}
          </Text>
        )}
        <Heading order={2}>{t("company:awaitingApproval.title")}</Heading>
        <Text>{t("company:awaitingApproval.body")}</Text>
        <Text>
          {t("company:awaitingApproval.questions")} <a href="mailto:info@reviver.no">info@reviver.no</a>
        </Text>
        {otherCompanies.length > 0 && (
          <Select
            data-testid="awaiting-approval-company-select"
            label={t("company:awaitingApproval.switchCompany")}
            data={otherCompanies.map((company) => ({ value: String(company.companyId), label: company.companyName }))}
            onChange={(value) => value && changeCompany(Number(value))}
          />
        )}
        <div>
          <CTA intent="secondary" data-testid="awaiting-approval-logout" onClick={() => signOut()}>
            {t("common:header.logout")}
          </CTA>
        </div>
      </Stack>
    </Container>
  );
}
